export const favoriteSessionsArray = [
  {
    title: 'CBT (Cock and Ball Torture)',
    description: 'Push your limits with precision and discipline.',
    image: '/images/cbt.jpg',
  },
  {
    title: 'Sploshing',
    description: 'Indulge in messy, decadent fun as I take full control.',
    image: '/images/sploshing.jpg',
  },
  {
    title: 'Session Wrestling',
    description: 'Feel my strength as I dominate you in a primal battle.',
    image: '/images/wrestling.jpg',
  },
  {
    title: 'MedFet (Medical Fetish)',
    description: 'Submit to clinical control as I explore your body with precision and authority.',
    image: '/images/medfet.jpg',
  },
  {
    title: 'Foot Worship',
    description: 'Kneel before me and show your devotion at my feet.',
    image: '/images/foot-worship.jpg',
  },
  {
    title: 'Impact Play',
    description: 'Feel the sting of discipline with every calculated strike.',
    image: '/images/impact-play.jpg',
  },
  {
    title: 'Facesitting & Ass/Body Worship',
    description: 'Be smothered, overwhelmed, and made to worship every inch of me.',
    image: '/images/facesitting-bodyworship.jpg',
  },
];
